import { TextLabel } from '@core/components/Inputs';
import { TableActionButton, TableActionContainer } from '@core/components/TableAction';
import { DataBR } from '@format';
import { Grid, makeStyles, Tooltip } from '@material-ui/core';
import { ClearAll, Edit } from '@material-ui/icons';
import { getCurrencySemSinalMonetario } from 'app/utils/monetarioUtil';
import React, { Fragment } from 'react';
import { FaEye, FaInfoCircle, FaPlus, FaSearch } from 'react-icons/fa';

const useStyles = makeStyles((theme) => ({
  btnContainer: {
    alignSelf: 'center',
  },
  btn: {
    background: '#5890aa',
    color: '#fff',
    width: '100%',
    height: 36,
    borderRadius: 5,
    textTransform: 'initial',
    transition: '0.4s',
    '&:hover': {
      background: '#335674',
    },
  },
  containerExtrato: {
    minHeight: '269px',
    maxHeight: '269px',
    overflow: 'scroll',
  },
  containerExtratoInfo: {
    minHeight: '255px',
    maxHeight: '255px',
  },
  customIcons: {
    fontSize: '16px',
  },
}));

export const VisualizacaoDespesaUnica = ({
  extrato,
  contaPagar,
  exibirTitulo,
  exibirAcoes,
  conciliado,
  handlerVisualizar,
  handlerEditar,
  handlerLimparInformacoes,
  temPermissaoParaVisualizar,
  temPermissaoParaEditar,
  exibirTooltipSemCorrespondencia,
  temPermissaoParaCadastrar,
  handlerLancarContaPagar,
  handlerPesquisar,
}) => {
  const tooltipSemCorrespondencia =
    'Este é um lançamento que já foi baixado no sistema, mas que ainda não possui outro ' +
    'semelhante nos extratos importados para que seja conciliado.';

  const classes = useStyles();

  const getBaixaInfo = (baixas, prop) => {
    const ultimaDataPagamento = baixas
      ?.map((baixa) => baixa?.dataPagamento)
      .sort((a, b) => new Date(b) - new Date(a))[0];

    const ultimaDataLiquidacao = baixas
      ?.map((baixa) => baixa?.dataLiquidacao)
      .sort((a, b) => new Date(b) - new Date(a))[0];

    const somatorioValoresPagos = baixas
      ?.map((baixa) => baixa?.valorPago)
      .reduce((acc, valorPago) => acc + (valorPago || 0), 0);

    if (prop === 'dataPagamento') {
      return ultimaDataPagamento;
    } else if (prop === 'dataLiquidacao') {
      return ultimaDataLiquidacao;
    } else if (prop === 'valorPago') {
      return somatorioValoresPagos;
    }
  };

  return (
    <Fragment>
      {exibirTitulo ? (
        <div style={{ margin: '15px 0px' }}>
          <b>DESPESA</b>
        </div>
      ) : (
        <></>
      )}
      <Grid container spacing={3}>
        {exibirTooltipSemCorrespondencia && (
          <Grid item xs={12} style={{ textAlign: 'end' }}>
            <Tooltip title={tooltipSemCorrespondencia} placement="right-end">
              <button type="button" onClick={() => {}}>
                <FaInfoCircle size={18} style={{ color: '#f2994a' }} />
              </button>
            </Tooltip>
          </Grid>
        )}
        <Grid item xs={12}>
          <TextLabel id="fornecedor" label="Fornecedor" value={contaPagar?.fornecedor?.pessoa?.nome} />
        </Grid>
        <Grid item xs={6}>
          <TextLabel
            id="dataPagamento"
            label="Data do pagamento"
            value={DataBR(getBaixaInfo(contaPagar?.baixas, 'dataPagamento'))}
          />
        </Grid>
        <Grid item xs={6}>
          <TextLabel
            id="dataLiquidacao"
            label="Data da liquidação"
            value={DataBR(getBaixaInfo(contaPagar?.baixas, 'dataLiquidacao'))}
          />
        </Grid>
        <Grid item xs={6}>
          <TextLabel
            id="categoria"
            label="Categoria"
            value={
              contaPagar?.categorias
                ? contaPagar?.categorias.length > 1
                  ? 'Categorias diversas'
                  : contaPagar?.categorias[0]
                  ? `${contaPagar?.categorias[0]?.classe?.indice} ${contaPagar?.categorias[0]?.classe?.nome}`
                  : '-'
                : '-'
            }
          />
        </Grid>
        <Grid item xs={6}>
          <TextLabel
            id="valor"
            label="Valor pago (R$)"
            value={getCurrencySemSinalMonetario(
              contaPagar?.valor ? contaPagar?.valor : getBaixaInfo(contaPagar?.baixas, 'valorPago')
            )}
          />
        </Grid>
        {exibirAcoes ? (
          <Grid item xs={12} style={{ padding: '5px 12px', textAlign: 'end' }}>
            <Fragment key={contaPagar?.id}>
              <TableActionContainer>
                {temPermissaoParaVisualizar && (
                  <TableActionButton
                    title="Visualizar"
                    icon={<FaEye size={16} />}
                    onClick={() => handlerVisualizar(contaPagar)}
                  />
                )}
                {!conciliado && (
                  <>
                    {temPermissaoParaEditar && (
                      <TableActionButton
                        title="Editar"
                        icon={<Edit size={12} className={classes.customIcons} />}
                        onClick={() => handlerEditar(contaPagar)}
                      />
                    )}
                    {temPermissaoParaVisualizar && (
                      <TableActionButton
                        title="Pesquisar conta"
                        icon={<FaSearch size={16} />}
                        onClick={() => handlerPesquisar()}
                      />
                    )}
                    {temPermissaoParaCadastrar && (
                      <TableActionButton
                        title="Lançar conta"
                        icon={<FaPlus size={16} />}
                        onClick={() => handlerLancarContaPagar()}
                      />
                    )}
                    <TableActionButton
                      title="Limpar informações"
                      icon={<ClearAll size={12} className={classes.customIcons} />}
                      onClick={() => handlerLimparInformacoes(undefined, contaPagar)}
                    />
                  </>
                )}
              </TableActionContainer>
            </Fragment>
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
    </Fragment>
  );
};

export const VisualizacaoDespesaLista = ({
  exibirTitulo,
  exibirAcoes,
  contaPagarList,
  conciliado,
  temPermissaoParaVisualizar,
  temPermissaoParaEditar,
  temPermissaoParaCadastrar,
  handlerVisualizar,
  handlerEditar,
  handlerLimparInformacoes,
  handlerLancarContaPagar,
  handlerPesquisar,
}) => {
  const classes = useStyles();
  return (
    <>
      {exibirTitulo ? (
        <div style={{ margin: '15px 0px' }}>
          <b>DESPESA</b>
        </div>
      ) : (
        <></>
      )}
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <b>Fornecedor</b>
        </Grid>
        <Grid item xs={3}>
          <b>Valor pago (R$)</b>
        </Grid>
        <Grid item xs={3} />
      </Grid>
      <Grid container spacing={3}>
        {contaPagarList?.map((contaPagar, index) => (
          <Grid container key={index}>
            <Grid item xs={6} style={{ padding: '5px 12px' }}>
              <Fragment key={contaPagar?.id}>
                <TextLabel id="lancamento.nome" label="" value={contaPagar?.fornecedor?.pessoa?.nome} />
              </Fragment>
            </Grid>
            <Grid item xs={3} style={{ padding: '5px 12px' }}>
              <Fragment key={contaPagar?.id}>
                <TextLabel
                  id="lancamento.valor"
                  label=""
                  value={
                    !!contaPagar.valor
                      ? getCurrencySemSinalMonetario(contaPagar.valor)
                      : !!contaPagar.baixas
                      ? getCurrencySemSinalMonetario(contaPagar.baixas.valorPago)
                      : getCurrencySemSinalMonetario(contaPagar.valorBruto)
                  }
                />
              </Fragment>
            </Grid>
            <Grid item xs={3} style={{ padding: '5px 12px', textAlign: 'end' }}>
              <Fragment key={contaPagar?.id}>
                <TableActionContainer>
                  {temPermissaoParaVisualizar && (
                    <TableActionButton
                      title="Visualizar"
                      icon={<FaEye size={16} />}
                      onClick={() => handlerVisualizar(contaPagar)}
                    />
                  )}
                  {!conciliado && (
                    <>
                      {temPermissaoParaEditar && (
                        <TableActionButton
                          title="Editar"
                          icon={<Edit size={12} className={classes.customIcons} />}
                          onClick={() => handlerEditar(contaPagar)}
                        />
                      )}
                      <TableActionButton
                        title="Limpar informações"
                        icon={<ClearAll size={12} className={classes.customIcons} />}
                        onClick={() => handlerLimparInformacoes(contaPagar)}
                      />
                    </>
                  )}
                </TableActionContainer>
              </Fragment>
            </Grid>
          </Grid>
        ))}
      </Grid>
      {exibirAcoes && (
        <Grid container spacing={3}>
          <Grid item xs={12} style={{ margin: '10px 0px', textAlign: 'end' }}>
            <TableActionContainer>
              {temPermissaoParaVisualizar && (
                <TableActionButton
                  title="Pesquisar conta"
                  icon={<FaSearch size={16} />}
                  onClick={() => handlerPesquisar()}
                />
              )}
              {temPermissaoParaCadastrar && (
                <TableActionButton
                  title="Lançar conta"
                  icon={<FaPlus size={16} />}
                  onClick={() => handlerLancarContaPagar()}
                />
              )}
              <TableActionButton
                title="Limpar informações"
                icon={<ClearAll size={12} className={classes.customIcons} />}
                onClick={() => handlerLimparInformacoes(undefined, contaPagarList[0], contaPagarList)}
              />
            </TableActionContainer>
          </Grid>
        </Grid>
      )}
    </>
  );
};

const VisualizacaoDespesa = ({
  extrato,
  contaPagarList,
  conciliado,
  handlerVisualizar,
  handlerEditar,
  handlerLimparInformacoes,
  exibirTooltipSemCorrespondencia,
  temPermissaoParaVisualizar,
  temPermissaoParaEditar,
  temPermissaoParaCadastrar,
  handlerLancarConta,
}) => {
  const visualizacaoUnica = () => {
    return extrato?.contaPagarList && extrato?.contaPagarList.length === 1 && !extrato?.contaPagarList[0].formulario;
  };

  const visualizacaoLista = () => {
    return extrato?.contaPagarList && extrato?.contaPagarList.length > 1;
  };

  return (
    <>
      {visualizacaoUnica() && (
        <VisualizacaoDespesaUnica
          extrato={extrato}
          contaPagar={extrato?.contaPagarList[0]}
          exibirTooltipSemCorrespondencia={exibirTooltipSemCorrespondencia}
        />
      )}
      {visualizacaoLista() && (
        <VisualizacaoDespesaLista
          contaPagarList={extrato?.contaPagarList}
          conciliado={extrato?.conciliado}
          temPermissaoParaVisualizar={temPermissaoParaVisualizar}
          temPermissaoParaEditar={temPermissaoParaEditar}
          temPermissaoParaCadastrar={temPermissaoParaCadastrar}
          handlerVisualizar={handlerVisualizar}
          handlerEditar={handlerEditar}
          handlerLimparInformacoes={handlerLimparInformacoes}
          handlerLancarContaPagar={handlerLancarConta}
        />
      )}
    </>
  );
};

export default VisualizacaoDespesa;
